/* GIFT HERO 1:1 with customsolo-made-for-love — 2026-09-16
   Carousel: slides / remember cards / dots rotate in sync every 5000ms
   (design measured: switch @5s period, all three tracks together).
   CTAs: primary navigates (default /pages/create), secondary scrolls to
   the story section when no url is configured (design buttons are inert;
   wiring kept functional without changing visuals). */
(function () {
  'use strict';

  function initHero(root) {
    var carousel = root.querySelector('[data-customsolo-hero-carousel]');
    if (!carousel) return;
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-customsolo-hero-slide]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-customsolo-hero-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.customsolo-gift-hero__dots button'));
    var n = Math.min(slides.length, dots.length || slides.length);
    if (!n) return;
    var idx = 0, timer = null;

    function apply(i) {
      idx = ((i % n) + n) % n;
      slides.forEach(function (el, k) { el.classList.toggle('is-active', k === idx); });
      if (dots.length === n) dots.forEach(function (el, k) {
        el.classList.toggle('is-active', k === idx);
        if (k === idx) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      });
      if (cards.length === n) cards.forEach(function (el, k) { el.classList.toggle('is-active', k === idx); });
    }

    function play() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = setInterval(function () { apply(idx + 1); }, 5000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (dots.length === n) dots.forEach(function (el, k) {
      el.addEventListener('click', function () { apply(k); play(); });
    });

    apply(0);
    play();
  }

  function initCtas(root) {
    var primary = root.querySelector('[data-cs-hero-cta="primary"]');
    if (primary) primary.addEventListener('click', function () {
      var url = primary.getAttribute('data-cs-hero-url') || '/pages/create';
      if (url) window.location.assign(url);
    });
    var secondary = root.querySelector('[data-cs-hero-cta="secondary"]');
    if (secondary) secondary.addEventListener('click', function () {
      var url = secondary.getAttribute('data-cs-hero-url');
      if (url) { window.location.assign(url); return; }
      var story = document.querySelector('[id*="story_explorer"], [id*="story-explorer"], .customsolo-story-section');
      if (story) story.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* Design sets the memory card width inline so it matches the action row
     (measured 452.28px on the live design; content column is 481px).
     Replicated dynamically so schema copy edits keep the alignment. */
  function syncMemoryCard(root) {
    var card = root.querySelector('.customsolo-memory-card');
    var actions = root.querySelector('.customsolo-gift-hero__actions');
    if (!card || !actions) return;
    var set = function () { card.style.width = actions.getBoundingClientRect().width + 'px'; };
    set();
    if (window.ResizeObserver) new ResizeObserver(set).observe(actions);
    window.addEventListener('resize', set);
  }

  function boot() {
    document.querySelectorAll('.customsolo-gift-hero').forEach(function (root) {
      initHero(root);
      initCtas(root);
      syncMemoryCard(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
